import { Component } from '@angular/core';
import { SidebarHeaderComponent } from './components/sidebar-header/sidebar-header.component';
import { SidebarFooterComponent } from './components/sidebar-footer/sidebar-footer.component';
import { SidebarItemsComponent } from './components/sidebar-items/sidebar-items.component';

@Component({
	selector: 'app-sidebar',
	standalone: true,
	imports: [SidebarHeaderComponent, SidebarFooterComponent, SidebarItemsComponent],
	templateUrl: './sidebar.component.html',
	styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {}
